import styled from 'styled-components';
import { AuthorName, Message } from '../styles';

export const StyledMessage = styled(Message)`
  flex-direction: column;
`;
export const StyledAuthorName = styled(AuthorName)`
  align-self: center !important;
`;
